import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'

const ChatSubmitButton = ({ iconTypeName, value, isDisabled, onClick }) => {
  return (
    <button
      className={`
        chat-submit-button
        ${isDisabled ? 'chat-submit-button--disabled' : ''}
      `}
      title={value}
      onClick={typeof onClick === 'function' && !isDisabled ? onClick : null}
    >
      <figure>
        <img
          src={getStaticImage(`/icons/orange-brand/icon-${iconTypeName}-primary-dark.svg`)}
          alt={value}
        />
      </figure>
    </button>
  )
}

export default ChatSubmitButton
